import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";
import { Heart, BookOpen, Users } from "lucide-react";

const HeroSection = () => {
  const { t } = useTranslation();
  
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="pt-32 pb-20 lg:pt-40 lg:pb-32 bg-gradient-to-b from-[#EDE7DC] to-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Content */}
          <div className="space-y-8 lg:pr-8">
            <div className="space-y-4">
              <h2 className="text-5xl lg:text-6xl font-serif font-bold text-[#2C3E50] leading-tight">
                {t('hero.name')}
              </h2>
              <div className="h-1 w-24 bg-[#7C9885]"></div>
            </div>

            <p className="text-xl lg:text-2xl text-[#5A6B6C] font-medium leading-relaxed">
              {t('hero.title')}
            </p>

            <p 
              className="text-lg text-[#5A6B6C] leading-relaxed"
              dangerouslySetInnerHTML={{ __html: t('hero.description') }}
            />

            <div className="flex flex-wrap gap-4 pt-4">
              <div className="flex items-center gap-2 text-[#7C9885]">
                <Heart className="w-5 h-5" />
                <span className="text-sm font-medium text-[#2C3E50]">{t('hero.relationshipCounseling')}</span>
              </div>
              <div className="flex items-center gap-2 text-[#7C9885]">
                <Users className="w-5 h-5" />
                <span className="text-sm font-medium text-[#2C3E50]">{t('hero.familyTherapy')}</span>
              </div>
              <div className="flex items-center gap-2 text-[#7C9885]">
                <BookOpen className="w-5 h-5" />
                <span className="text-sm font-medium text-[#2C3E50]">{t('hero.educationCounseling')}</span>
              </div>
            </div>

            <div className="pt-6">
              <Button
                onClick={scrollToContact}
                className="bg-[#7C9885] hover:bg-[#6A8573] text-white px-8 py-6 text-lg transition-all duration-200 hover:shadow-lg"
              >
                {t('hero.cta')}
              </Button>
            </div>
          </div>

          {/* Right: Photo */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_dc794182-497b-4ff7-b14a-107a2aeb474a/artifacts/ilb5kg1w_359BD4D4-7287-4056-99D8-24A7FE96C392.jpeg"
                alt="Redouan Chabou - Professional Counselor"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -z-10 top-8 -right-8 w-64 h-64 bg-[#7C9885]/20 rounded-full blur-3xl"></div>
            <div className="absolute -z-10 -bottom-8 -left-8 w-64 h-64 bg-[#C17A6F]/20 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;